module.exports = __webpack_public_path__ + "static/media/sell_send_money_2.0e85e1bc.jpg";